export const mySchedule = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',

  TabInit: { display: 'none', show: (() => { let d = false; return (el, s) => { if (!d) { d = true; Promise.resolve().then(() => s.root.update({ activeTab: 'mySchedule', viewMode: s.root.viewMode || 'week' })) } return false } })() },

  NavSidebar: {},

  MainContent: {
    flow: 'y', flex: '1', overflow: 'auto',
    TopBar: {},

    ContentArea: {
      flow: 'y', gap: 'B', padding: 'B', flex: '1',
      '@mobileL': { padding: 'A' },

      // ─── DOCTOR HEADER ─────────────────────────────
      DoctorHeader: {
        flow: 'x', gap: 'B', align: 'center flex-start', flexWrap: 'wrap',
        Avatar: {
          width: 'C', height: 'C', round: 'C', background: 'teal.20',
          align: 'center center', flexShrink: '0',
          Initials: { text: 'AK', fontSize: 'A', fontWeight: '700', color: 'teal' }
        },
        Info: {
          flow: 'y', gap: 'X',
          Name: { text: 'Dr. Ana Lomidze', fontSize: 'B', fontWeight: '700', color: 'inkText' },
          Role: { text: 'General & Restorative Dentist · Cabinet 1', fontSize: 'Z', color: 'inkMuted' },
          StatusRow: {
            flow: 'x', gap: 'Y', align: 'center flex-start',
            ActiveDot: { width: 'Y', height: 'Y', round: 'Y', background: 'green', flexShrink: '0' },
            StatusText: { text: 'On Duty · Next patient in 12 min', fontSize: 'Y', color: 'green' }
          }
        },
        Spacer: { flex: '1' },
        TodayDate: { text: 'Wed, Mar 19, 2026', fontSize: 'Z', color: 'inkMuted', alignSelf: 'flex-start', paddingTop: 'Y' }
      },

      // ─── TODAY STATS ───────────────────────────────
      TodayStats: {
        display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 'Z',

        StatAppts: {
          flow: 'y', gap: 'X', padding: 'Z A', round: 'Z', background: 'teal.10', border: '1px solid teal.25',
          Val: { text: '6', fontSize: 'B', fontWeight: '700', color: 'teal' },
          Lbl: { text: 'Appointments', fontSize: 'Y', color: 'inkMuted' }
        },
        StatDone: {
          flow: 'y', gap: 'X', padding: 'Z A', round: 'Z', background: 'green.10', border: '1px solid green.25',
          Val: { text: '2', fontSize: 'B', fontWeight: '700', color: 'green' },
          Lbl: { text: 'Completed', fontSize: 'Y', color: 'inkMuted' }
        },
        StatRemaining: {
          flow: 'y', gap: 'X', padding: 'Z A', round: 'Z', background: 'amber.10', border: '1px solid amber.25',
          Val: { text: '4', fontSize: 'B', fontWeight: '700', color: 'amber' },
          Lbl: { text: 'Remaining', fontSize: 'Y', color: 'inkMuted' }
        },
        StatProduction: {
          flow: 'y', gap: 'X', padding: 'Z A', round: 'Z', background: 'purple.10', border: '1px solid purple.25',
          Val: { text: '₾3,240', fontSize: 'B', fontWeight: '700', color: 'purple' },
          Lbl: { text: 'Est. Production', fontSize: 'Y', color: 'inkMuted' }
        }
      },

      // ─── NEXT PATIENT CARD ─────────────────────────
      NextPatientCard: {
        flow: 'x', gap: 'A', padding: 'A', round: 'A', background: 'teal.08', border: '2px solid teal.30', align: 'center flex-start', flexWrap: 'wrap',
        NextLabel: {
          flow: 'y', gap: 'X', flexShrink: '0',
          Tag: { text: 'NEXT PATIENT', fontSize: 'Y', fontWeight: '700', color: 'teal', letterSpacing: '0.08em' },
          Time: { text: '10:00 AM', fontSize: 'A', fontWeight: '700', color: 'inkText' }
        },
        Divider: { width: '1px', background: 'teal.30', alignSelf: 'stretch', flexShrink: '0' },
        PatientInfo: {
          flow: 'y', gap: 'X', flex: '1',
          PatName: { text: 'Giorgi Beridze', fontSize: 'A', fontWeight: '700', color: 'inkText' },
          Procedure: { text: 'RCT #36 · 60 min · Cabinet 1', fontSize: 'Z', color: 'inkMuted' },
          Notes: { text: 'Check periapical X-ray before start. Patient is slightly anxious.', fontSize: 'Y', color: 'inkSubtle', fontStyle: 'italic' }
        },
        PatientActions: {
          flow: 'x', gap: 'Y', flexShrink: '0',
          ViewChartBtn: { tag: 'button', text: 'View Chart', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', round: 'Z', background: 'teal', color: 'ink', border: 'none', cursor: 'pointer' },
          CheckInBtn: { tag: 'button', text: 'Check In', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', round: 'Z', background: 'inkSurface', color: 'inkText', border: '1px solid inkBorder', cursor: 'pointer' }
        }
      },

      // ─── TOOLBAR ───────────────────────────────────
      ScheduleToolbar: {
        flow: 'x', gap: 'A', align: 'center space-between', flexWrap: 'wrap',
        '@mobileL': { flow: 'y', gap: 'Z' },

        LeftControls: {
          flow: 'x', gap: 'Z', align: 'center flex-start',
          ViewToggle: {
            flow: 'x', gap: '0', round: 'Y', overflow: 'hidden', border: '1px solid inkBorder',
            DayBtn: {
              text: '{{ day | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', cursor: 'pointer',
              background: (el, s) => s.root.viewMode === 'day' ? 'teal' : 'inkMid',
              color: (el, s) => s.root.viewMode === 'day' ? 'white' : 'inkMuted',
              onClick: (e, el, s) => s.root.update({ viewMode: 'day' })
            },
            WeekBtn: {
              text: '{{ week | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', cursor: 'pointer',
              background: (el, s) => s.root.viewMode === 'week' ? 'teal' : 'inkMid',
              color: (el, s) => s.root.viewMode === 'week' ? 'white' : 'inkMuted',
              onClick: (e, el, s) => s.root.update({ viewMode: 'week' })
            }
          },
          DateNav: {
            flow: 'x', gap: 'Y', align: 'center center',
            PrevBtn: { text: '←', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', cursor: 'pointer' },
            TodayBtn: { text: '{{ today | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'teal', cursor: 'pointer' },
            NextBtn: { text: '→', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', cursor: 'pointer' },
            DateLabel: { text: 'Mar 17 – Mar 23, 2026', fontSize: 'Z', fontWeight: '600', color: 'inkText', marginLeft: 'Y' }
          }
        },

        RightControls: {
          flow: 'x', gap: 'Z', align: 'center flex-end',
          BlockTimeBtn: { tag: 'button', text: 'Block Time', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkMuted', cursor: 'pointer' },
          NewApptBtn: { tag: 'button', text: '+ New Appointment', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', round: 'Y', background: 'teal', color: 'ink', border: 'none', cursor: 'pointer' }
        }
      },

      // ─── WEEK CALENDAR (MY APPOINTMENTS ONLY) ─────
      WeekCalendarSection: {
        flow: 'y', background: 'inkMid', round: 'A', border: '1px solid inkBorder', overflow: 'auto',

        DayHeaders: {
          display: 'grid', gridTemplateColumns: '60px repeat(5, 1fr)', borderBottom: '1px solid inkBorder', position: 'sticky', top: '0', background: 'inkMid', zIndex: '1',
          TimeCol: { padding: 'Z' },
          MonHead: { padding: 'Z Y', textAlign: 'center', fontSize: 'Y', fontWeight: '600', color: 'inkText', borderLeft: '1px solid inkBorder', text: 'MON 17' },
          TueHead: { padding: 'Z Y', textAlign: 'center', fontSize: 'Y', fontWeight: '600', color: 'teal', borderLeft: '1px solid inkBorder', text: 'TUE 18' },
          WedHead: { padding: 'Z Y', textAlign: 'center', fontSize: 'Y', fontWeight: '600', color: 'teal', borderLeft: '1px solid inkBorder', text: 'WED 19', background: 'teal.05' },
          ThuHead: { padding: 'Z Y', textAlign: 'center', fontSize: 'Y', fontWeight: '600', color: 'inkText', borderLeft: '1px solid inkBorder', text: 'THU 20' },
          FriHead: { padding: 'Z Y', textAlign: 'center', fontSize: 'Y', fontWeight: '600', color: 'inkText', borderLeft: '1px solid inkBorder', text: 'FRI 21' }
        },

        Row0800: {
          display: 'grid', gridTemplateColumns: '60px repeat(5, 1fr)', borderBottom: '1px solid inkBorder', minHeight: 'C',
          TimeLabel: { padding: 'Y Z', fontSize: 'Y', color: 'inkMuted', textAlign: 'right', text: '08:00' },
          MonSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          TueSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          WedSlot: { borderLeft: '1px solid inkBorder', padding: 'Y', background: 'teal.03' },
          ThuSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          FriSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' }
        },

        Row0900: {
          display: 'grid', gridTemplateColumns: '60px repeat(5, 1fr)', borderBottom: '1px solid inkBorder', minHeight: 'C',
          TimeLabel: { padding: 'Y Z', fontSize: 'Y', color: 'inkSubtle', textAlign: 'right', text: '09:00', fontWeight: '600' },
          MonSlot: { borderLeft: '1px solid inkBorder', padding: 'Y',
            Evt: { text: 'Crown Prep #14', fontSize: 'Z', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Y', color: 'inkText', background: 'teal.08',
              PatName: { text: 'T. Kapanadze', fontSize: 'Y', color: 'inkMuted' },
              StatusTag: { text: 'Confirmed', fontSize: 'Y', color: 'green', fontWeight: '600' }
            }
          },
          TueSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          WedSlot: { borderLeft: '1px solid inkBorder', padding: 'Y', background: 'teal.03' },
          ThuSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          FriSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' }
        },

        Row1000: {
          display: 'grid', gridTemplateColumns: '60px repeat(5, 1fr)', borderBottom: '1px solid inkBorder', minHeight: 'C',
          TimeLabel: { padding: 'Y Z', fontSize: 'Y', color: 'inkSubtle', textAlign: 'right', text: '10:00', fontWeight: '600' },
          MonSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          TueSlot: { borderLeft: '1px solid inkBorder', padding: 'Y',
            Evt: { text: 'RCT #36', fontSize: 'Z', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Y', color: 'inkText', background: 'teal.08',
              PatName: { text: 'G. Beridze', fontSize: 'Y', color: 'inkMuted' },
              StatusTag: { text: 'Confirmed', fontSize: 'Y', color: 'green', fontWeight: '600' }
            }
          },
          WedSlot: { borderLeft: '1px solid inkBorder', padding: 'Y', background: 'teal.03' },
          ThuSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          FriSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' }
        },

        Row1100: {
          display: 'grid', gridTemplateColumns: '60px repeat(5, 1fr)', borderBottom: '1px solid inkBorder', minHeight: 'C',
          TimeLabel: { padding: 'Y Z', fontSize: 'Y', color: 'inkSubtle', textAlign: 'right', text: '11:00', fontWeight: '600' },
          MonSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          TueSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          WedSlot: { borderLeft: '1px solid inkBorder', padding: 'Y', background: 'teal.03',
            Evt: { text: 'Implant Consult', fontSize: 'Z', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Y', color: 'inkText', background: 'teal.08',
              PatName: { text: 'N. Kapanadze', fontSize: 'Y', color: 'inkMuted' },
              StatusTag: { text: 'Confirmed', fontSize: 'Y', color: 'green', fontWeight: '600' }
            }
          },
          ThuSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          FriSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' }
        },

        Row1200: {
          display: 'grid', gridTemplateColumns: '60px repeat(5, 1fr)', borderBottom: '1px solid inkBorder', minHeight: 'C',
          TimeLabel: { padding: 'Y Z', fontSize: 'Y', color: 'inkSubtle', textAlign: 'right', text: '12:00', fontWeight: '600' },
          MonSlot: { borderLeft: '1px solid inkBorder', padding: 'Y', LunchLabel: { text: '— Lunch —', fontSize: 'Y', color: 'inkMuted', fontStyle: 'italic' } },
          TueSlot: { borderLeft: '1px solid inkBorder', padding: 'Y', LunchLabel: { text: '— Lunch —', fontSize: 'Y', color: 'inkMuted', fontStyle: 'italic' } },
          WedSlot: { borderLeft: '1px solid inkBorder', padding: 'Y', background: 'teal.03', LunchLabel: { text: '— Lunch —', fontSize: 'Y', color: 'inkMuted', fontStyle: 'italic' } },
          ThuSlot: { borderLeft: '1px solid inkBorder', padding: 'Y', LunchLabel: { text: '— Lunch —', fontSize: 'Y', color: 'inkMuted', fontStyle: 'italic' } },
          FriSlot: { borderLeft: '1px solid inkBorder', padding: 'Y', LunchLabel: { text: '— Lunch —', fontSize: 'Y', color: 'inkMuted', fontStyle: 'italic' } }
        },

        Row1300: {
          display: 'grid', gridTemplateColumns: '60px repeat(5, 1fr)', borderBottom: '1px solid inkBorder', minHeight: 'C',
          TimeLabel: { padding: 'Y Z', fontSize: 'Y', color: 'inkSubtle', textAlign: 'right', text: '13:00', fontWeight: '600' },
          MonSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          TueSlot: { borderLeft: '1px solid inkBorder', padding: 'Y',
            Evt: { text: 'Veneer Prep #11', fontSize: 'Z', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Y', color: 'inkText', background: 'teal.08',
              PatName: { text: 'K. Gabrichidze', fontSize: 'Y', color: 'inkMuted' },
              StatusTag: { text: 'Completed', fontSize: 'Y', color: 'teal', fontWeight: '600' }
            }
          },
          WedSlot: { borderLeft: '1px solid inkBorder', padding: 'Y', background: 'teal.03' },
          ThuSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          FriSlot: { borderLeft: '1px solid inkBorder', padding: 'Y',
            Evt: { text: 'Composite #25', fontSize: 'Z', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Y', color: 'inkText', background: 'teal.08',
              PatName: { text: 'S. Meladze', fontSize: 'Y', color: 'inkMuted' },
              StatusTag: { text: 'Confirmed', fontSize: 'Y', color: 'green', fontWeight: '600' }
            }
          }
        },

        Row1400: {
          display: 'grid', gridTemplateColumns: '60px repeat(5, 1fr)', borderBottom: '1px solid inkBorder', minHeight: 'C',
          TimeLabel: { padding: 'Y Z', fontSize: 'Y', color: 'inkSubtle', textAlign: 'right', text: '14:00', fontWeight: '600' },
          MonSlot: { borderLeft: '1px solid inkBorder', padding: 'Y',
            Evt: { text: 'Bridge Prep #34-36', fontSize: 'Z', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Y', color: 'inkText', background: 'teal.08',
              PatName: { text: 'R. Kharazishvili', fontSize: 'Y', color: 'inkMuted' },
              StatusTag: { text: 'Confirmed', fontSize: 'Y', color: 'green', fontWeight: '600' }
            }
          },
          TueSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          WedSlot: { borderLeft: '1px solid inkBorder', padding: 'Y', background: 'teal.03',
            Evt: { text: 'Extraction #48', fontSize: 'Z', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Y', color: 'inkText', background: 'teal.08',
              PatName: { text: 'V. Papunashvili', fontSize: 'Y', color: 'inkMuted' },
              StatusTag: { text: 'Completed', fontSize: 'Y', color: 'teal', fontWeight: '600' }
            }
          },
          ThuSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          FriSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' }
        },

        Row1500: {
          display: 'grid', gridTemplateColumns: '60px repeat(5, 1fr)', borderBottom: '1px solid inkBorder', minHeight: 'C',
          TimeLabel: { padding: 'Y Z', fontSize: 'Y', color: 'inkSubtle', textAlign: 'right', text: '15:00', fontWeight: '600' },
          MonSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          TueSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          WedSlot: { borderLeft: '1px solid inkBorder', padding: 'Y', background: 'teal.03' },
          ThuSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          FriSlot: { borderLeft: '1px solid inkBorder', padding: 'Y',
            Evt: { text: 'Crown Seat #14', fontSize: 'Z', padding: 'Y Z', round: 'Y', borderLeft: '3px solid teal', paddingLeft: 'Y', color: 'inkText', background: 'teal.08',
              PatName: { text: 'T. Kapanadze', fontSize: 'Y', color: 'inkMuted' },
              StatusTag: { text: 'Confirmed', fontSize: 'Y', color: 'green', fontWeight: '600' }
            }
          }
        },

        Row1600: {
          display: 'grid', gridTemplateColumns: '60px repeat(5, 1fr)', borderBottom: '1px solid inkBorder', minHeight: 'C',
          TimeLabel: { padding: 'Y Z', fontSize: 'Y', color: 'inkSubtle', textAlign: 'right', text: '16:00', fontWeight: '600' },
          MonSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          TueSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          WedSlot: { borderLeft: '1px solid inkBorder', padding: 'Y', background: 'teal.03' },
          ThuSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          FriSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' }
        },

        Row1700: {
          display: 'grid', gridTemplateColumns: '60px repeat(5, 1fr)', minHeight: 'C',
          TimeLabel: { padding: 'Y Z', fontSize: 'Y', color: 'inkSubtle', textAlign: 'right', text: '17:00', fontWeight: '600' },
          MonSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          TueSlot: { borderLeft: '1px solid inkBorder', padding: 'Y',
            Evt: { text: 'Emergency Walk-in', fontSize: 'Z', padding: 'Y Z', round: 'Y', borderLeft: '3px solid red', paddingLeft: 'Y', color: 'inkText', background: 'red.08',
              PatName: { text: 'L. Mchedlishvili', fontSize: 'Y', color: 'inkMuted' },
              StatusTag: { text: 'In Chair', fontSize: 'Y', color: 'blue', fontWeight: '600' }
            }
          },
          WedSlot: { borderLeft: '1px solid inkBorder', padding: 'Y', background: 'teal.03' },
          ThuSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' },
          FriSlot: { borderLeft: '1px solid inkBorder', padding: 'Y' }
        }
      }
    },
    MobileTabBar: {}
  }
}
